import * as React from 'react';

export type AuthContextValue = {
  isAuthenticated: boolean;
  // Mutation hooks (useLoginMutation, etc.) are imported directly by consumers.
  // The context only exposes the boolean status used by RouterContext.
};

export const AuthContext = React.createContext<AuthContextValue | null>(null);
